"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDiscount = exports.findMatchingDiscount = exports.findMatchingSize = exports.round = exports.quotedPriceBuild = exports.normalizeMaterialSize = exports.waysteQuotedPriceBuild = exports.applyDiscountToMaterial = exports.calculatePaymentFee = exports.findTaxRate = exports.VERSION = void 0;
exports.sortFees = sortFees;
exports.calculatePricing = calculatePricing;
const transport_types_1 = require("@alliance-disposal/transport-types");
exports.VERSION = 4;
const priceTypesEnums = {
    ton: 'ton',
    yard: 'yard',
    flat: 'flat',
    tonVariableHaul: 'tonVariableHaul',
};
const round = (number, radix = 1) => {
    const modulus = number % radix;
    const rounded = number - modulus;
    if (modulus >= radix / 2) {
        return rounded + radix;
    }
    return rounded;
};
exports.round = round;
const nextDollar = (price) => {
    const radix = 100;
    const modulus = price % radix;
    const rounded = price - modulus;
    if (modulus > 0) {
        return rounded + radix;
    }
    return rounded;
};
/**
 * @deprecated - use tax rates from pricing service under field actualTaxRate
 */
const findTaxRate = () => {
    throw new Error('Removed. Use tax rates from pricing service under field actualTaxRate');
};
exports.findTaxRate = findTaxRate;
const calculatePaymentFee = (invoiceTotal, fee) => {
    if (fee.type === 'PAYMENT_FEE') {
        // convert the fee amount to a decimal from basis points
        const decimal = fee.amount / 10000;
        const fixed = fee.paymentFeeFixedAmount || 0;
        // inorder to calculate the payment fee we need to know the amount of the payment fee we need to do total + fixed amount / 1 - percent
        const paymentFee = (invoiceTotal + fixed) / (1 - decimal);
        return Math.ceil(paymentFee - invoiceTotal);
    }
    return 0;
};
exports.calculatePaymentFee = calculatePaymentFee;
const normalizeSize = (material, size) => {
    let multiplier;
    switch (material.type) {
        case priceTypesEnums.ton:
            multiplier = size.tonLimit || 0;
            break;
        case priceTypesEnums.yard:
            multiplier = Number(size.size) || 0;
            break;
        case priceTypesEnums.flat:
            multiplier = 0;
            break;
        case priceTypesEnums.tonVariableHaul:
            multiplier = size.tonLimit || 0;
            break;
        default:
            multiplier = 0;
            break;
    }
    return {
        dump: +(size.dump || 0),
        tax: material.tax,
        size: Number(size.size),
        type: material.type,
        haul: size.haul,
        tonLimit: size.tonLimit || 0,
        overage: size.over || 0,
        multiplier,
    };
};
const normalizeMaterialSize = (material) => {
    const sizes = material.sizes.map((size) => normalizeSize(material, size));
    return {
        material: material.material,
        tax: material.tax,
        type: material.type,
        sizes,
        doesNotService: material.doesNotService,
        allowOnlineCheckout: material.allowOnlineCheckout,
    };
};
exports.normalizeMaterialSize = normalizeMaterialSize;
const quotedPriceBuild = (tonLimit, dumpRate, haulRate, taxRate, roundTotal, over, fees) => {
    // so for something to be a "credit card fee" it has to be a fee that applied to the total, and will have forPaymentMethod = 'creditCard'
    const ccFee = fees === null || fees === void 0 ? void 0 : fees.find((fee) => fee.forPaymentMethod === 'CREDIT_CARD' &&
        fee.type === 'PERCENT' &&
        fee.howToApply === 'TOTAL' &&
        fee.whereToApply === 'ALWAYS');
    const ccRate = ((ccFee === null || ccFee === void 0 ? void 0 : ccFee.amount) || 0) / 10000; // convert from basis points to decimal (dividing avoids floating point errors)
    // console.log(tonLimit, dumpRate, haulRate, taxRate, ccRate, roundTotal, over);
    const dumpFinal = dumpRate * tonLimit;
    const taxHaul = round(haulRate * taxRate);
    const overage = nextDollar((over || dumpRate) / (1 - ccRate));
    const rawTotal = (haulRate + dumpFinal + taxHaul) / (1 - ccRate);
    if (!roundTotal) {
        return {
            haul: haulRate,
            dump: dumpFinal,
            tax: round(taxHaul),
            cc: round(rawTotal * ccRate),
            total: round(rawTotal),
            fees: [
                {
                    name: 'Credit Card Fee',
                    type: 'payment_fee',
                    amount: round(rawTotal * ccRate),
                    taxable: false,
                },
            ],
            overage: round(overage),
            totalWithoutTax: round(rawTotal - round(taxHaul)),
            totalWithoutFees: 0,
            totalWithoutTaxOrFees: 0,
            tonLimit: tonLimit,
            version: exports.VERSION,
        };
    }
    // const total = Math.ceil(rawTotal);
    const total = Math.ceil(rawTotal / 500) * 500;
    const ccFinal = total * ccRate;
    const haulWTax = total - dumpFinal - ccFinal;
    const haulFinal = haulWTax / (1 + taxRate);
    const taxFinal = haulWTax - haulFinal;
    // console.log('haulFinal', haulFinal);
    return {
        haul: round(haulFinal),
        dump: dumpFinal,
        tax: round(taxFinal),
        cc: round(ccFinal),
        fees: [
            {
                name: 'Credit Card Fee',
                type: 'payment_fee',
                amount: round(ccFinal),
                taxable: false,
            },
        ],
        total: total,
        overage: round(overage),
        totalWithoutFees: 0,
        totalWithoutTaxOrFees: 0,
        totalWithoutTax: round(total - round(taxFinal)),
        tonLimit: tonLimit,
        version: exports.VERSION,
    };
};
exports.quotedPriceBuild = quotedPriceBuild;
function sortFees(fees) {
    const sortOrder = {
        LINE_ITEM: 1,
        HAUL: 2,
        DUMP: 3,
        OVER: 4,
        SUBTOTAL: 5,
        TOTAL: 6,
    };
    return fees.sort((a, b) => {
        // First, sort by howToApply category
        if (sortOrder[a.howToApply] < sortOrder[b.howToApply]) {
            return -1;
        }
        else if (sortOrder[a.howToApply] > sortOrder[b.howToApply]) {
            return 1;
        }
        // Then, sort by fee type (fixed or percent) within each category
        if (a.type === 'FIXED' && b.type === 'PERCENT') {
            return -1;
        }
        else if (a.type === 'PERCENT' && b.type === 'FIXED') {
            return 1;
        }
        return 0;
    });
}
const waysteQuotedPriceBuild = (tonLimit, dumpRate, haulRate, taxRate, over, options) => {
    var _a;
    // so for something to be a "credit card fee" it has to be a fee that applied to the total, and will have forPaymentMethod = 'creditCard'
    const calculateFeeAmount = (fee, amount) => {
        if (fee.type === 'PERCENT') {
            return (amount * fee.amount) / 10000;
        }
        else if (fee.type === 'FIXED') {
            return fee.amount;
        }
        return 0; // should never happen
    };
    const dumpFinal = dumpRate * tonLimit;
    const taxDump = (options === null || options === void 0 ? void 0 : options.taxDump) ? round(dumpFinal * taxRate) : 0;
    const taxHaul = (options === null || options === void 0 ? void 0 : options.taxHaul) ? round(haulRate * taxRate) : 0;
    const overage = over || dumpRate;
    const taxOver = (options === null || options === void 0 ? void 0 : options.taxOver) ? round(overage * taxRate) : 0;
    const subtotal = haulRate + dumpFinal;
    let tax = taxHaul + taxOver + taxDump;
    let totalWithFees = subtotal;
    const calculatedFees = [];
    if (options === null || options === void 0 ? void 0 : options.fees) {
        sortFees(options.fees
            .filter((fee) => fee.type !== 'PAYMENT_FEE')
            .filter((fee) => (fee.whereToApply === 'ALWAYS' ||
            fee.whereToApply === 'FIRST_ORDER' ||
            ((options === null || options === void 0 ? void 0 : options.includeManualFees) && fee.whereToApply === 'MANUAL')) &&
            fee.howToApply !== 'TOTAL')).forEach((fee) => {
            // for each how to apply we need to handle it differently
            let amount = 0;
            switch (fee.howToApply) {
                // this is intentionally fall through (total and subtotal are the same thing total just has to be applied last)
                case 'SUBTOTAL':
                    amount = calculateFeeAmount(fee, subtotal);
                    break;
                case 'HAUL':
                    amount = calculateFeeAmount(fee, haulRate);
                    break;
                case 'DUMP':
                    amount = calculateFeeAmount(fee, dumpFinal);
                    break;
                case 'OVER':
                    amount = calculateFeeAmount(fee, overage);
                    break;
                case 'LINE_ITEM':
                    amount = fee.amount;
                    break;
                case 'TOTAL':
                    // skip total because we apply it last
                    break;
                default:
                    throw new Error('Unknown how to apply');
            }
            if (amount > 0) {
                totalWithFees += amount;
                calculatedFees.push({
                    name: fee.name,
                    amount: round(amount),
                    taxable: fee.taxable,
                    type: 'regular_fee',
                });
            }
        });
    }
    // loop through all calculated fees and calculate the tax on them and add it to the tax
    calculatedFees.forEach((fee) => {
        if (fee.taxable) {
            tax += round(fee.amount * taxRate);
        }
    });
    // now we need to add any final total fees (these fees can never be taxable) but not payment fees, they must be applied last
    if (options === null || options === void 0 ? void 0 : options.fees) {
        sortFees(options.fees
            .filter((fee) => fee.type !== 'PAYMENT_FEE')
            .filter((fee) => (fee.whereToApply === 'ALWAYS' || fee.whereToApply === 'FIRST_ORDER' || fee.whereToApply === 'MANUAL') &&
            fee.howToApply === 'TOTAL')).forEach((fee) => {
            const amount = calculateFeeAmount(fee, totalWithFees);
            totalWithFees += amount;
            calculatedFees.push({
                name: fee.name,
                amount: round(amount),
                taxable: false,
                type: 'regular_fee',
            });
        });
    }
    // now lets calculate our totals
    let total = totalWithFees + tax;
    // now we calculate the cc fee
    const paymentFees = ((_a = options === null || options === void 0 ? void 0 : options.fees) === null || _a === void 0 ? void 0 : _a.filter((fee) => fee.type === 'PAYMENT_FEE')) || [];
    if (paymentFees.length > 1) {
        throw new Error('Only one payment fee is allowed');
    }
    const paymentFee = paymentFees === null || paymentFees === void 0 ? void 0 : paymentFees[0];
    if (paymentFee) {
        const paymentFeeAmount = (0, exports.calculatePaymentFee)(total, paymentFee);
        calculatedFees.push({
            name: 'Credit Card Fee',
            amount: paymentFeeAmount,
            taxable: false,
            type: 'payment_fee',
        });
        total += paymentFeeAmount;
    }
    return {
        haul: haulRate,
        dump: dumpFinal,
        tonLimit: tonLimit,
        overage: round(overage),
        totalWithoutFees: round(subtotal),
        totalWithoutTaxOrFees: round(subtotal),
        totalWithoutTax: round(totalWithFees),
        tax: round(tax),
        fees: calculatedFees,
        total: round(total),
        version: exports.VERSION,
        cc: 0, // deprecated in favor of fees
    };
};
exports.waysteQuotedPriceBuild = waysteQuotedPriceBuild;
const findMatchingSize = (pricing, selectedMaterial) => {
    // check if pricing is sg pricing
    if (pricing.hasOwnProperty('pricingData')) {
        const pricingData = pricing.pricingData.find((material) => material.material === selectedMaterial.material);
        const size = pricingData === null || pricingData === void 0 ? void 0 : pricingData.sizes.find((size) => Number(size.size) === selectedMaterial.size);
        return { pricingData: { ...pricingData }, size: { ...size } };
    }
    //if not sg pricing, then it is hauler pricing and uses materials instead of pricingData
    const pricingData = pricing.materials.find((material) => material.details.material === selectedMaterial.material);
    const size = pricingData === null || pricingData === void 0 ? void 0 : pricingData.details.sizes.find((size) => Number(size.size) === selectedMaterial.size);
    return {
        pricingData: {
            ...pricingData === null || pricingData === void 0 ? void 0 : pricingData.details,
            allowOnlineCheckout: true,
        },
        size: { ...size },
    };
};
exports.findMatchingSize = findMatchingSize;
const findMatchingDiscount = (pricing, selectedMaterial) => {
    const foundDiscountData = pricing.discountData.find((material) => material.material === selectedMaterial.material);
    const foundDiscountSize = foundDiscountData === null || foundDiscountData === void 0 ? void 0 : foundDiscountData.sizes.find((size) => Number(size.size) === selectedMaterial.size);
    return { foundDiscountData, foundDiscountSize };
};
exports.findMatchingDiscount = findMatchingDiscount;
const applyDiscount = (value, discount, type) => {
    const discountValue = {
        [transport_types_1.Pricing.CustomerDiscountType.PERCENTAGE]: (value, discount) => value * (1 - discount * 0.0001),
        [transport_types_1.Pricing.CustomerDiscountType.DOLLAR]: (value, discount) => value - discount,
        [transport_types_1.Pricing.CustomerDiscountType.FIXED]: (_, discount) => discount,
    };
    return discountValue[type](value, discount);
};
exports.applyDiscount = applyDiscount;
const applyDiscountToMaterial = (pricing, discount, tonsAlreadyApplied) => {
    const { size } = pricing;
    const { foundDiscountSize, discounts } = discount;
    if (foundDiscountSize.dump) {
        if (size.dump) {
            size.dump = applyDiscount(size.dump, foundDiscountSize.dump, discounts.discountType);
        }
    }
    if (foundDiscountSize.over) {
        if (size.over) {
            size.over = applyDiscount(size.over, foundDiscountSize.over, discounts.discountType);
        }
    }
    if (foundDiscountSize.haul) {
        size.haul = applyDiscount(size.haul || 0, foundDiscountSize.haul, discounts.discountType);
    }
    if (foundDiscountSize.tonLimit != null && !tonsAlreadyApplied) {
        size.tonLimit = (size.tonLimit || 0) + foundDiscountSize.tonLimit;
        if (discounts.discountType === 'FIXED') {
            size.tonLimit = foundDiscountSize.tonLimit;
        }
    }
};
exports.applyDiscountToMaterial = applyDiscountToMaterial;
/**
 *
 * @param pricing - pricing data from hauler or sourgum
 * @param configuration  - material, size, payment method, additional fees, weight limit, tax exempt, tax rate, credit card fee, round total, over
 * @param discounts - customer discounts
 * @param log - optional log output
 * @returns {QuotedPrice}
 */
function calculatePricing(pricing, configuration, discounts, log = false) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { pricingData, size } = findMatchingSize(pricing, configuration);
    (_a = configuration.taxableLineItems) !== null && _a !== void 0 ? _a : (configuration.taxableLineItems = [...transport_types_1.Invoice.DefaultTaxableLineItems]);
    if (log)
        console.log(size);
    if (!pricingData) {
        throw new Error('Material not found');
    }
    if (!size) {
        throw new Error('Size not found');
    }
    else {
        if (log)
            console.log(size.tonLimit);
        size.tonLimit = configuration.weightLimit || size.tonLimit || 0;
        if (configuration.weightLimit === 0) {
            size.tonLimit = 0;
        }
    }
    if (log)
        console.log(size.tonLimit);
    if (discounts) {
        const { foundDiscountData, foundDiscountSize } = findMatchingDiscount(discounts, configuration);
        if (foundDiscountData && foundDiscountSize) {
            (0, exports.applyDiscountToMaterial)({ pricingData, size }, { discounts, foundDiscountData, foundDiscountSize }, Boolean(configuration.weightLimit));
        }
    }
    const normalizedPricing = normalizeMaterialSize({
        allowOnlineCheckout: !!pricingData.allowOnlineCheckout,
        doesNotService: !!pricingData.doesNotService,
        material: pricingData.material,
        tax: pricingData.tax,
        type: pricingData.type,
        sizes: [size],
    });
    const normalizedSize = normalizedPricing.sizes[0];
    let taxRate = 0;
    if (!configuration.taxExempt) {
        if (pricing.actualTaxRate) {
            taxRate = pricing.actualTaxRate;
        }
        if (configuration.taxRate) {
            taxRate = configuration.taxRate;
        }
    }
    if (pricing.fees) {
        configuration.additionalFees = [
            ...pricing.fees,
            ...(configuration.additionalFees || []),
        ];
    }
    // if it's a not a first time order we can filter out fees with whereToApply being FIRST_ORDER
    if (!configuration.notFirstOrder) {
        configuration.additionalFees = (_b = configuration.additionalFees) === null || _b === void 0 ? void 0 : _b.filter((fee) => fee.whereToApply !== 'FIRST_ORDER');
    }
    if (pricing.type === 'GENERAL') {
        // this is hauler pricing use the waysteQuotedPriceBuild
        const quotedPrice = waysteQuotedPriceBuild(normalizedSize.multiplier, normalizedSize.dump, normalizedSize.haul || 0, taxRate || 0, // normalizedSize.tax ? taxRate : 0,
        (_c = configuration.over) !== null && _c !== void 0 ? _c : (normalizedSize.overage || 0), {
            fees: [...(configuration.additionalFees || [])],
            taxHaul: configuration.taxExempt
                ? false
                : ((_d = configuration.taxableLineItems) === null || _d === void 0 ? void 0 : _d.includes('QP-Haul')) || ((_e = configuration.taxableLineItems) === null || _e === void 0 ? void 0 : _e.includes('haul')),
            taxDump: configuration.taxExempt
                ? false
                : ((_f = configuration.taxableLineItems) === null || _f === void 0 ? void 0 : _f.includes('QP-Dump')) || ((_g = configuration.taxableLineItems) === null || _g === void 0 ? void 0 : _g.includes('dump')),
            taxOver: configuration.taxExempt ? false : (_h = configuration.taxableLineItems) === null || _h === void 0 ? void 0 : _h.includes('Overage'),
        });
        if (log)
            console.log(quotedPrice);
        return quotedPrice;
    }
    const quotedPrice = quotedPriceBuild(normalizedSize.multiplier, normalizedSize.dump, normalizedSize.haul || 0, normalizedSize.tax ? taxRate : 0, (_j = configuration.roundTotal) !== null && _j !== void 0 ? _j : true, (_k = configuration.over) !== null && _k !== void 0 ? _k : (normalizedSize.overage || 0), [...(configuration.additionalFees || [])]);
    if (log)
        console.log(quotedPrice);
    return quotedPrice;
}
//# sourceMappingURL=V4.js.map